export enum MEDICARE_APPOINTMENT_SCOPES {
  MEDICARE_PART_D = 'medicare_part_d',
  MEDICARE_PART_C = 'medicare_part_c',
  DENTAL_VISION_HEARING = 'dental_vision_hearing',
  HOSPITAL_PRODUCTS = 'hospital_products',
  SUPPLEMENT_PRODUCTS = 'supplement_products'
}
